
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import utils from './../utils';
import { StorageServiceProvider } from './storage.service';
import { StorageKeys } from '../_constants';

@Injectable({
  providedIn: 'root' 
})
export class QuotesServiceProvider {

  constructor(private http: HttpClient, private storage: StorageServiceProvider) { }
  getQuotes(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      let agentId = localStorage.getItem('AgentId');
      let dataSet = this.storage.get(StorageKeys.DataSet);
      let user = JSON.parse(localStorage.getItem('agrisLicense'));
      let username = '';
      if (user)
        username = user.username;
      let disableQuotesExpiry = (localStorage.getItem('settings')) ? JSON.parse((localStorage.getItem('settings'))).disableQuotesExpiry : true;

      let tenentId = dataSet ? dataSet.TenantID : '';
      let sessionId =  this.storage.get(StorageKeys.Settings).agentSessionId.replace('}', '').replace('{', '');
      let remoteUrl = `${utils.GetSalesReviewRemoteServer()}/Bookings/quotes/${agentId}/${tenentId}/${sessionId}/${username}?transactionType=quote&filterExpiration=${!disableQuotesExpiry}`;
      this.http.get(remoteUrl, {
        headers: {},
      }).pipe(map(data => data)).subscribe(data => {
        resolve(data);
      },
        (error) => {
          reject(error);
        }
      );
    })
    return promise;
  }
  getItems(bookingId, location): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      let agentId = localStorage.getItem('AgentId');
      let dataSet = this.storage.get(StorageKeys.DataSet);
      let tenentId = dataSet ? dataSet.TenantID : '';
     let settings = this.storage.get(StorageKeys.Settings);;
      let sessionId = settings.agentSessionId.replace('}', '').replace('{', '');
      let remoteUrl = `${utils.GetSalesReviewRemoteServer()}/Bookings/bookingItems/${bookingId}/${tenentId}/${sessionId}/${location}`;
      this.http.get(remoteUrl, {
        headers: {},
      }).pipe(map(data => data)).subscribe(data => {
        resolve(data);
      },
        (error) => {
          reject(error);
        }
      );
    })
    return promise;
  }
  deleteQuote(bookingId, user): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      let remoteUrl = `${utils.GetSalesReviewRemoteServer()}/Bookings/softdeleteBooking/${bookingId}/${user}`;
      this.http.get(remoteUrl, {
        headers: {},
      }).pipe(map(data => data)).subscribe(data => {
        resolve(data);
      },
        (error) => {
          reject(error);
        }
      );
    })
    return promise;
  }
  voidPendingQuote(booking) {
    return new Promise((resolve, reject) => {
      let remoteUrl = `${utils.GetSalesReviewRemoteServer()}/Bookings/approvebooking`;
      this.http.post(remoteUrl, booking, {
        headers: {},
      }).pipe(map(data => data)).subscribe(data => {
        resolve(data);
      },
        (error) => {
          reject(error);
        }
      );
    });
  }
}
